import React, { useState } from "react";
import styles from "./ElixirTestimonial.module.scss";

// More testimonials can be appended here later — the carousel adapts to length.
const TESTIMONIALS = [
  {
    quote:
      "Elchemy has transformed the way we manage procurement. From instant access to technical documentation to real-time order visibility, their platform has made sourcing faster, more transparent, and far more reliable. It's become an essential part of our procurement workflow.",
    author:
      "Procurement Associate, Global Personal Care Manufacturer | USA",
  },
  {
    quote:
      "Managing multiple high value orders across regions used to be time-consuming. With Elchemy, we've streamlined sourcing, reduced back-and-forth communication, and gained complete visibility into every order. The platform saves our team valuable time every week.",
    author: "Supply Chain Manager, Specialty Chemicals Company | Italy",
  },
  {
    quote:
      "The combination of reliable inventory, digital documentation, and responsive support has significantly improved our purchasing experience. Elchemy's technology gives us the confidence to make faster sourcing decisions while staying compliant.",
    author:
      "Head of Strategic Sourcing, Food & Beverage Ingredients Manufacturers | USA",
  },
];

function ElixirTestimonial() {
  const [active, setActive] = useState(0);
  const current = TESTIMONIALS[active];

  return (
    <section className={styles.testimonial}>
      <div className={styles.content}>
        <p className={styles.quote}>
          <span className={styles.mark}>&ldquo;</span>
          {current.quote}
          <span aria-hidden="true">&rdquo;</span>
        </p>

        <div className={styles.footer}>
          <p className={styles.attribution}>- {current.author}</p>

          <div className={styles.dots} role="tablist" aria-label="Testimonials">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                type="button"
                role="tab"
                aria-selected={active === i}
                aria-label={`Testimonial ${i + 1}`}
                className={`${styles.dot} ${active === i ? styles.dotActive : ""}`}
                onClick={() => setActive(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ElixirTestimonial;
